export const VAAction = (payload) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        let result = { ...payload }
        dispatch({ type: "VA_ACTION_KEY", payload: result });
        resolve({ success: true })
    });
}